module.exports = __webpack_public_path__ + "static/media/B_retro_blue.345b4fe3.png";